import { render, staticRenderFns } from "./PageCreateMethodComponent.vue?vue&type=template&id=2f98b301&"
import script from "./PageCreateMethodComponent.vue?vue&type=script&lang=js&"
export * from "./PageCreateMethodComponent.vue?vue&type=script&lang=js&"
import style0 from "./PageCreateMethodComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports